import { useState, useEffect } from "react";
import styles from "./Support.module.scss";
import { axiosInstance } from "../../services";
import { useTranslation } from "react-i18next";
import localesKeys from "../../locales/localesKeys.json";

const TermAndCondition = () => {
  const {
    i18n: { language },
    t,
  } = useTranslation();
  const [terms, setTerms] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const getTerms = async () => {
    try {
      const response = await axiosInstance.get("/singleton/termsCondition");
      setTerms(response?.data?.data || {});
    } catch (error) {
      console.error("Error fetching terms. Please try again!!");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTerms();
  }, []);

  return (
    <div className={styles.container}>
      {isLoading ? (
        <div>Loading....</div>
      ) : (
        <div className={styles.container__inner}>
          <div className={styles.container__inner__title}>
            <h1>{t(localesKeys.FOOTER_SUPPORTLIST_SERVICES)}</h1>
          </div>
          <div className="ql-editor">
            <div
              className={styles.container__inner__content}
              dangerouslySetInnerHTML={{ __html: terms?.[language] }}
            ></div>
          </div>
        </div>
      )}
    </div>
  );
};
export default TermAndCondition;
